import { GetDashboardUsageReportsQueryVariables, useGetDashboardUsageReportsQuery } from 'src/api';

type DashboardUsageReportsHookParams = {
  variables: GetDashboardUsageReportsQueryVariables;
  skip?: boolean;
};

export const useDashboardUsageReports = (params: DashboardUsageReportsHookParams) => {
  const { variables, skip } = params;

  const { data, loading: isDashboardUsageReportsLoading } = useGetDashboardUsageReportsQuery({
    variables,
    skip,
  });

  const dashboardUsageReportsItems = data?.getDashboardUsageReports ?? [];

  return {
    dashboardUsageReportsItems,
    isDashboardUsageReportsLoading,
  };
};
